import gql from 'graphql-tag'

export default gql`
	query listStandardCustomerPositions {
		cashAssist {
			listStandardCustomerPositions {
				id
				position
			}
		}
	}
`
